export default __webpack_public_path__ + "static/comments-dark-f76d24e4e654a0715cfa243901ee5fa3.png";